<template>
  <div  v-if="newList?.length === 12" style="width: 100%">
    <router-link
      class="mobile-news"
      :to="
        $i18nRoute({
          name: 'NewsDetail',
          params: { slug: newList[newList.length - 1]?.url }
        })
      "
    >
      <div class="img">
        <ImageContainer
          :src="newList[newList.length - 1].image.medium"
          :thumb="newList[newList.length - 1].image.thumbnail"
          :alt="newList[newList.length - 1].title"
        />
      </div>
      <div class="gradient bottom"></div>
      <div class="gradient top"></div>
      <div class="meta">
        <div class="date">
          {{ handleDate(newList[newList.length - 1]?.pub_date, "dd mmmm") }}
        </div>
        <div class="category">
          {{ newList[newList.length - 1]?.sub_category.name }}
        </div>
        <div class="title">
          {{ newList[newList.length - 1]?.title }}
        </div>
      </div>
    </router-link>
    <div
      style="
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
      "
    >
      <div class="left-collar"></div>
      <div class="main-content">
        <div class="left">
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
            class="news-item"
            v-for="(item, index) in newList.slice(0, 5)"
            :key="item.id"
            :style="`grid-area: card-${index + 1}`"
          >
            <div class="img-holder">
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
            </div>
            <div class="cat-wrapper">
              <div class="cat-meta">{{ item.sub_category.name }}</div>
            </div>
            <div class="title limited-text">
              {{ item.title }}
            </div>
            <div class="date-wrapper">
              <span class="date">{{ handleDate(item.pub_date) }},</span>
              <span class="date" style="padding-left: 0.44em">{{
                handleTime(item.pub_date)
              }}</span>
            </div>
          </router-link>
        </div>
        <div class="right">
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
            class="news-item"
            v-for="(item, index) in newList.slice(5, 13)"
            :key="item.id"
            :style="`grid-area: card-${index + 1}`"
          >
            <div class="img-holder">
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
            </div>
            <div class="cat-wrapper">
              <div class="cat-meta">{{ item.sub_category.name }}</div>
            </div>
            <div class="title limited-text">
              {{ item.title }}
            </div>
            <div
              v-if="index === 6"
              class="brief"
            >
            <p class="limited-text" style="--snup: 6">

              {{ item.brief }}
            </p>
            </div>
            <div class="date-wrapper">
              <span class="date">{{ handleDate(item.pub_date) }},</span>
              <span class="date" style="padding-left: 0.44em">{{
                handleTime(item.pub_date)
              }}</span>
            </div>
          </router-link>
          <div
            class="news-lines"
            v-for="index in 2"
            :key="index"
            :style="`grid-area: empty-${index}`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
import { ref } from "vue";

export default {
  name: "FirstBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      d: true
    }
  },
  setup(props) {
    const newList = ref(props.list ?? []);

    const { moveArrayItemToNewIndex } = useFormatter();

    if (window.innerWidth <= 768) {
      newList.value = moveArrayItemToNewIndex(
        newList.value,
        0,
        newList.value.length - 1
      );
    }

    return {
      newList,
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.mobile-news {
  display: none;
  width: 100%;
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  font-family: Open Sans;
  margin-bottom: 0.4rem;

  .img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &.bottom {
      background-image: linear-gradient(transparent, var(--background-color));
    }

    &.top {
      background-image: linear-gradient(var(--background-color), transparent);
      opacity: 0.2;
    }
  }

  .meta {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .title {
      position: relative;
      width: 94%;
      font-size: 2.2em;
      line-height: 1.2em;
      letter-spacing: 0.03em;
      font-family: Roboto;
      padding-bottom: 2em;
      padding-top: 2rem;
    }

    .category {
      position: relative;
      width: 94%;
      font-size: 1.7em;
      line-height: 1.5em;
    }

    .date {
      position: relative;
      width: 94%;
      font-size: 1.8em;
      line-height: 1.4em;
      text-transform: lowercase;
    }
  }
}

.left-collar {
  top: 0;
  right: 0;
  position: absolute;
  height: 100%;
  width: calc(100% - var(--left-whole-width));
  background-color: var(--foreground-color);
  border-bottom-left-radius: 4px;
  pointer-events: none;
}

.main-content {
  position: relative;
  width: 90%;
  display: flex;
  justify-content: center;

  .news-lines {
    height: 1px;
    background-color: var(--background-color);
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .left {
    padding-top: 1.375rem;
    // max-width: var(--left-width);
    // flex: 0 1 40%;
    // width: 40%;
    max-width: 44.45%;
    height: auto;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "card-1 card-1"
      "card-2 card-3"
      "card-4 card-5";

    .news-item {
      height: auto;
      position: relative;
      padding-bottom: 2.125rem;
      margin: 0 2rem;

      &:hover {
        img {
          transform: scale(1.14);
        }
      }

      .img-holder {
        border-radius: 4px;
        position: relative;
        padding-top: 56.25%; /* 16:9 Aspect Ratio */
        overflow: hidden;

        .img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      .cat-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        background-color: var(--background-color);
        height: 1.6em;
        font-family: Open Sans;

        .cat-meta {
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0.375rem;
          }
        }
      }

      .title {
        font-family: Roboto;
        font-size: 1.25em;
        font-weight: 500;
        line-height: 1.5em;
        padding-top: 0.625rem;
      }

      .date-wrapper {
        font-weight: 300;
        font-size: 0.875em;
        padding-top: 0.75em;
        opacity: 0.8;
        font-family: Open Sans;
      }
    }
  }

  .right {
    padding-top: 2.375rem;
    padding-bottom: 2.375rem;
    flex: 1 0 55%;
    background-color: var(--foreground-color);
    border-radius: 0 0 0 4px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto 1px auto 1px auto;
    row-gap: 1.5rem;
    grid-template-areas:
      "card-1 card-1 card-1 card-2 card-2 card-2"
      "empty-1 empty-1 empty-1 empty-1 empty-1 empty-1"
      "card-3 card-3 card-4 card-4 card-5 card-5"
      "empty-2 empty-2 empty-2 empty-2 empty-2 empty-2"
      "card-6 card-6 card-7 card-7 card-7 card-7";

    .news-item {
      height: auto;
      position: relative;
      color: var(--secondary-font-color);
      padding: 0 1rem;

      &:nth-child(1),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(6) {
        border-right: 1px solid var(--background-color);
      }

      &:nth-child(7) {
        display: grid;
        grid-template-areas:
          "category image"
          "title image"
          "brief image"
          "date image";
        column-gap: 1rem;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 30px auto 1fr auto;

        .img-holder {
          grid-area: image;
          width: 100%;
          height: 100%;
          padding-top: 0;

          .img {
            position: relative;
          }
        }

        .cat-wrapper {
          grid-area: category;
          position: relative;
          left: 0;
          top: 0;

          .cat-meta {
            &:first-child {
              padding-left: 0;
            }
          }
        }

        .title {
          grid-area: title;
          height: auto;
          margin-bottom: 0.8rem;
        }

        .date-wrapper {
          grid-area: date;
        }

        .brief {
          grid-area: brief;
          // height: 78%;
        }
      }

      .img-holder {
        width: 100%;
        border-radius: 4px;
        padding-top: 59.09%; /* 22:13 Aspect Ratio */
        position: relative;
        overflow: hidden;

        .img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 4px;
          transition: all 0.4s ease;
        }
      }

      .cat-wrapper {
        position: absolute;
        left: 1rem;
        top: 0;
        display: flex;
        align-items: center;
        background-color: var(--foreground-color);
        height: 1.6em;
        font-family: Open Sans;
        .cat-meta {
          display: flex;
          align-items: center;
          justify-content: center;
          &:first-child {
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0.375rem;
          }
        }
      }

      .title {
        font-family: Roboto;
        font-size: 1.25em;
        font-weight: 500;
        line-height: 1.5em;
        padding-top: 0.625rem;
      }

      .date-wrapper {
        font-weight: 300;
        font-size: 0.875em;
        padding-top: 0.75em;
        opacity: 0.8;
        font-family: Open Sans;
      }
    }
  }

  .empty {
    width: 1px;
    height: 90%;
    background-color: var(--background-color);
  }
}

@media screen and (max-width: 1666px) {
  .main-content {
    .news-lines {
      height: 0;
      background-color: none;
      margin-left: 0;
      margin-right: 0;
      display: none;
    }
    .right {
      width: 100%;
      grid-template-rows: auto;
      grid-template-areas:
        "card-1 card-1 card-1 card-2 card-2 card-2"
        "card-3 card-3 card-3 card-4 card-4 card-4"
        "card-5 card-5 card-5 card-6 card-6 card-6"
        "card-7 card-7 card-7 card-7 card-7 card-7";
      grid-gap: 0;
      row-gap: 1.5rem;

      .news-item {
        &:nth-child(7) {
          .img-holder {
            width: 100%;
            border-radius: 4px;
            padding-top: 59.09%; /* 22:13 Aspect Ratio */
            position: relative;
            overflow: hidden;
            height: unset;

            .img {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              border-radius: 4px;
              transition: all 0.4s ease;
            }
          }
        }
      }
    }

    .news-item {
      border-right: none !important;
    }
  }
}
@media screen and (max-width: 1366px) {
  .main-content {
    .news-lines {
      height: 1px;
      background-color: var(--background-color);
      margin-left: 1rem;
      margin-right: 1rem;
    }

    .left {
      padding-top: 1.375rem;
      // max-width: var(--left-width);
      height: auto;
      display: grid;
      grid-template-areas:
        "card-1 card-1"
        "card-2 card-3"
        "card-4 card-5";

      .news-item {
        height: auto;
        position: relative;
        padding-bottom: 2.125rem;
        margin: 0rem;
        padding-left: 1rem;
        padding-right: 1rem;

        &:hover {
          img {
            transform: scale(1.14);
          }
        }

        .cat-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          align-items: center;
          background-color: var(--background-color);
          height: 1.6em;
          font-family: Open Sans;

          .cat-meta {
            display: flex;
            align-items: center;
            justify-content: center;

            &:first-child {
              font-weight: 600;
              text-transform: uppercase;
              padding: 0 0.375rem;
            }
          }
        }

        .title {
          font-size: 1.25em;
          font-weight: 500;
          line-height: 1.5rem;
          padding-top: 0.625rem;
        }

        .date-wrapper {
          font-weight: 300;
          font-size: 0.875em;
          padding-top: 0.75em;
          opacity: 0.8;
          font-family: Open Sans;
        }
      }
    }

    .right {
      padding-top: 2.375rem;
      padding-bottom: 2.375rem;
      flex: 1 0 0;
      background-color: var(--foreground-color);
      border-radius: 0 0 0 4px;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: auto 1px auto 1px auto;
      row-gap: 1.5rem;
      grid-template-areas:
        "card-1 card-1 card-1 card-2 card-2 card-2"
        "empty-1 empty-1 empty-1 empty-1 empty-1 empty-1"
        "card-3 card-3 card-4 card-4 card-5 card-5"
        "empty-2 empty-2 empty-2 empty-2 empty-2 empty-2"
        "card-6 card-6 card-7 card-7 card-7 card-7";

      .news-item {
        height: auto;
        position: relative;
        color: var(--secondary-font-color);
        padding: 0 1rem;

        &:nth-child(1),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(6) {
          border-right: 1px solid var(--background-color) !important;
        }

        &:nth-child(7) {
          display: grid;
          grid-template-areas:
            "category image"
            "title image"
            "brief image"
            "date image";
          grid-template-columns: 1fr 1fr;

          .cat-wrapper {
            grid-area: category;
            position: relative;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            // background-color: var(--background-color);
            height: 1.6em;
            font-family: Open Sans;
          }

          .title {
            grid-area: title;
            font-family: Roboto;
            font-size: 1.25em;
            font-weight: 500;
            line-height: 1.25rem;
          }

          .date-wrapper {
            grid-area: date;
            font-weight: 300;
            font-size: 0.875em;
            padding-left: 0.425rem;
            padding-top: 2.75em;
            opacity: 0.8;
            font-family: Open Sans;
          }
        }

        .cat-wrapper {
          position: absolute;
          left: 1rem;
          top: 0;
          display: flex;
          align-items: center;
          background-color: var(--foreground-color);
          height: 1.6em;

          .cat-meta {
            display: flex;
            align-items: center;
            justify-content: center;
            &:first-child {
              font-weight: 600;
              text-transform: uppercase;
              padding: 0 0.375rem;
            }
          }
        }

        .title {
          font-size: 1.25em;
          font-weight: 500;
          line-height: 1.25rem;
          padding-top: 0.625rem;
        }

        .date-wrapper {
          font-weight: 300;
          font-size: 0.875em;
          padding-top: 0.75em;
          opacity: 0.8;
        }
      }

      .news-lines {
        display: block;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .main-content {
    // .left {
    //   grid-template-areas:
    //     "card-1 card-1"
    //     "card-2 card-2"
    //     "card-3 card-3"
    //     "card-4 card-4"
    //     "card-5 card-5";
    // }

    .news-lines {
      height: 0;
      background-color: none;
      margin-left: 0;
      margin-right: 0;
      display: none;
    }

    .right {
      grid-template-rows: auto;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        "card-1 card-2"
        "card-3 card-4"
        "card-5 card-6"
        "card-7 card-7";
      grid-gap: 0;
      row-gap: 1.5rem;

      .news-item {
        &:nth-child(1),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(6) {
          border: none !important;
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .mobile-news {
    display: flex;
  }

  .main-content {
    width: unset;
    .left {
      width: 25%;
      grid-template-areas:
        "card-1 card-1"
        "card-2 card-2"
        "card-3 card-3"
        "card-4 card-4"
        "card-5 card-5";
    }

    .right {
      border-radius: 4px;
      padding-bottom: 2.375rem;
      width: 100%;
      grid-template-rows: repeat(3, 1fr) 0;
      grid-gap: 0;

      .news-item {
        border-right: none !important;
        &:nth-child(7) {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 630px) {
  .mobile-news {
    padding-top: 62.5%; /* 16:10 Aspect Ratio */

    .title {
      font-size: 20px;
    }

    .category {
      font-size: 20px;
    }

    .date {
      font-size: 20px;
    }
  }

  .main-content {
    .left {
      max-width: 35%;
      grid-template-areas:
        "card-1 card-1"
        "card-2 card-2"
        "card-3 card-3"
        "card-4 card-4"
        "card-5 card-5";

      .news-item {
        width: 70%;
        height: auto;

        .title {
          font-size: 1em;
          font-weight: 600;
          line-height: 1.5rem;
        }

        .date-wrapper {
          grid-area: date;
          font-size: 0.775em;
          padding-top: 2.75em;
        }
        .cat-wrapper {
          font-size: 10px;
          height: 1.2rem;
        }
      }
    }
  }
}

@media screen and (min-width: 993px) {
  .main-content {
    .left {
      .news-item {
        &:first-child {
          .title {
            text-align: center;
          }

          .date-wrapper {
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 550px) {
  .mobile-news {
    padding-top: 68.75%; /* 16:11 Aspect Ratio */

    .meta {
      .title {
        font-size: 1.5em;
      }

      .category {
        font-size: 1.15em;
      }

      .date {
        font-size: 1em;
      }
    }
  }

  .main-content {
    .left {
      width: 45%;
      height: 100%;
      display: grid;
      grid-template-areas:
        "card-1 card-1"
        "card-2 card-2"
        "card-3 card-3"
        "card-4 card-4"
        "card-5 card-5";
      margin-left: 2%;
      // grid-template-rows: repeat(5, 260px);

      .news-item {
        width: 100%;
        height: 100%;
        position: relative;
        padding-bottom: 2.125rem;
        margin: 0;

        &:hover {
          img {
            transform: none;
          }
        }

        .img-holder {
          display: none;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 12px;
          width: 85%;
          height: 130px;
          --snup: 6;
        }

        .date-wrapper {
          font-weight: 300;
          font-size: 0.8em;
          padding-top: 0.75em;
          opacity: 0.8;
          font-family: Open Sans;
        }

        .cat-wrapper {
          position: absolute;
          left: -4px;
          top: -0.8em;
          height: 0;
          font-size: 0.9em;
          display: flex;
          align-items: center;
          background-color: none;
        }
      }
    }
    .right {
      padding-top: 1rem;
      padding-bottom: 1rem;
      height: 100%;
      width: 100%;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(6, 1fr);
      grid-template-areas:
        "card-1"
        "card-2"
        "card-3"
        "card-4"
        "card-5"
        "card-6";
      row-gap: 1.5rem;

      .news-item {
        height: auto;
        position: relative;
        color: var(--secondary-font-color);
        border-right: none !important;
        padding: 0 0.8rem;

        .cat-wrapper {
          font-size: 0.9em;
          height: 1.6em;
          left: 0.8rem;
        }

        .title {
          font-family: Roboto;
          font-size: 1em;
          font-weight: 500;
          line-height: 1.5em;
          padding-top: 0.625rem;
        }

        .date-wrapper {
          font-weight: 300;
          font-size: 0.775em;
          padding-top: 0.75em;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
